import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
    (config) => {
        // Check both possible token keys (match sectionsAPI.js)
        const token = localStorage.getItem('token') || localStorage.getItem('authToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle common errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('authUser');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  // Registration
  register: (userData) => api.post('/api/auth/register', userData),

  // Login (supports both email and phone)
  login: (credentials) => api.post('/api/auth/login', credentials),

  // UNIFIED VERIFICATION - handles both email tokens and phone OTP
  verify: (verificationData) => api.post('/api/auth/verify', verificationData),

  // Resend verification (works for both email and phone)
  resendVerification: ({ email, phone }) => {
  return api.get('/api/auth/resend-verification', {
    params: {
      email: email || undefined,
      phone: phone || undefined,
    },
  });
},


  // MFA verification
  verifyMFA: (mfaData) => api.post('/api/auth/verify-mfa', mfaData),

  // Update MFA settings
  updateMFA: (mfaSettings) => api.post('/api/auth/update-mfa', mfaSettings),

  // Password management
  forgotPassword: (emailData) => api.post('/api/auth/forgot-password', emailData),

  resetPassword: (resetData) => api.post('/api/auth/reset-password', resetData),

  changePassword: (passwordData) => api.post('/api/auth/change-password', passwordData),

  // Account unlock functionality
  unlockAccount: ({ token, answers }) => api.post('/api/auth/unlock', { token, answers }),

  // Set new password after unlock
  unlockNewPassword: ({ token, newPassword, confirmPassword }) =>
    api.post('/api/auth/unlock-new-password', { token, newPassword, confirmPassword }),

  // Profile routes
  updateProfile: (profileData) => api.post('/api/profile', profileData),
  getProfile: () => api.get('/api/profile'),

  // Logout routes
  logout: () => api.post('/api/profile/logout'),

  // User deletion
  deleteUser: (email) => api.delete('/api/auth/deleteUser', { data: { email } }),
};

export default authAPI;
